import { useEffect, useState } from 'react';
import { Link, NavLink } from 'react-router-dom';
import { NAV_LINKS } from '../../constants/navigation';

export function Header({ onNavClick }) {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);

  useEffect(() => {
    if (!mobileMenuOpen) return undefined;
    const previousOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = previousOverflow;
    };
  }, [mobileMenuOpen]);

  const closeMenu = () => {
    setMobileMenuOpen(false);
    onNavClick?.();
  };

  const toggleMenu = () => setMobileMenuOpen((open) => !open);

  const navClass = ({ isActive }) =>
    `hover:text-secondary transition-colors ${isActive ? 'text-secondary' : ''}`;

  return (
    <header className="sticky top-0 z-50 relative bg-darker/80 backdrop-blur-md border-b border-purple-900/40">
      <div className="container mx-auto px-4 py-4 flex justify-between items-center">
        <Link to="/" className="flex items-center space-x-2" onClick={closeMenu}>
          <span className="text-xl font-bold">Ameowzing</span>
        </Link>
        <nav className="hidden md:flex space-x-8 text-sm">
          {NAV_LINKS.map((link) => (
            <NavLink key={link.path} to={link.path} className={navClass}>
              {link.label}
            </NavLink>
          ))}
        </nav>
        <button
          type="button"
          className="md:hidden text-2xl text-light"
          aria-label={mobileMenuOpen ? '关闭菜单' : '打开菜单'}
          aria-expanded={mobileMenuOpen}
          onClick={toggleMenu}
        >
          <i className={`fa ${mobileMenuOpen ? 'fa-times' : 'fa-bars'}`} />
        </button>
      </div>
      {mobileMenuOpen && (
        <button
          type="button"
          className="md:hidden fixed inset-0 z-40 bg-black/50"
          aria-label="关闭菜单"
          onClick={closeMenu}
        />
      )}
      <nav
        className={`${
          mobileMenuOpen ? 'block' : 'hidden'
        } md:hidden absolute top-full left-0 right-0 z-50 border-t border-purple-900/40 bg-darker/95 backdrop-blur-md shadow-xl max-h-[calc(100vh-4rem)] overflow-y-auto`}
        aria-hidden={!mobileMenuOpen}
      >
        <div className="container mx-auto px-4 py-4 flex flex-col space-y-3">
          {NAV_LINKS.map((link) => (
            <NavLink
              key={link.path}
              to={link.path}
              className={({ isActive }) =>
                `py-2 hover:text-secondary ${isActive ? 'text-secondary' : ''}`
              }
              onClick={closeMenu}
            >
              {link.label}
            </NavLink>
          ))}
        </div>
      </nav>
    </header>
  );
}
